import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";
import { useToast } from "../../../common_nextgen/hooks/ToastContext";
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";
import getBackendUrl from "../../../environment/BackendService";
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";

const useDrugStatusSchedule = (
  onSelect,
  hideModal,
  selectParams,
  selectMode,
  lookupType,
  selectedSchedule
) => {
  const {
    ADD_DRUG_STATUS_SCHEDULE,
    EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
    EDIT_DRUG_STATUS_SCHEDULE,
    DISPLAY_DRUG_STATUS_SCHEDULE,
    BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
  } = ROUTE_PATHS;
  const location = useLocation();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("select params", selectParams);
  const {
    selectedSchedules = [],
    previousScreen = BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
    selectedDescriptions = [],
    currentIndex: initialIndex = 0,
    initialParamsData = {
      bmdScheduleCode: selectedSchedules[initialIndex]?.bmdScheduleCode,
      bmdDescription: selectedDescriptions[initialIndex]?.bmdDescription,
      bddDrugStatus: "Blank",
    },
  } = currentState;
  const initialQueryParams = selectMode
    ? {
        bmdScheduleCode: selectedSchedule[0]?.bmdScheduleCode,
        bmdDescription: selectedSchedule[0]?.bmdDescription,
        bddDrugStatus: "Blank",
      }
    : initialParamsData;
  console.log("initialParamsData", initialParamsData, previousState);
  const [paramsData, setParamsData] = useState(initialQueryParams);
  const [data, setData] = useState([]);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [rowData, setRowData] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const navigateToPage = useCustomNavigate();
  const [dropdownValues, setDropdownValues] = useState({});
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("no");
  const toast = useToast();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const { axios_helper_no_header } = useAxios();

  const screen_title = "Drug Status in Benefit Max Drug Status Schedule";
  const screenNumber = "RCBDD001";
  const bddPreferredStatus = "bddPreferredStatus";

  const formFields = [
    {
      fieldLabel: "Schedule",
      name: "bmdScheduleCode",
      label: "Schedule",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 10,
    },
    {
      fieldLabel: "Description",
      name: "bmdDescription",
      label: "Description",
      type: "text",
      fieldNature: "readOnly",
      value: "",
      maxLength: 30,
    },
    {
      fieldLabel: "Plan Default Drug Status*ALL values",
      name: "bddDrugStatus",
      label: "Code",
      type: "dropdown",
      fieldNature: "editable",
      value: "",
      maxLength: 1,
    },
  ];

  const dropdownOptions = [
    { field_label: "Plan Default Drug Status", condition: "*ALL values" },
  ];

  const dropdownCondition = {
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),
  };

  const ctaButtons = selectMode
    ? []
    : [
        {
          button_label: "Add Drug Status in Benefit Max Drug Status Schedule",
          button_handeler: () => {
            navigateToPage(ADD_DRUG_STATUS_SCHEDULE, [
              ...previousState,
              { ...currentState, currentIndex },
              {
                selectedSchedules: selectedSchedules,
                selectedDescriptions: selectedDescriptions,
                bddDrugStatus: selectedRows.length ? selectedRows : [rowData],
                bddPreferredStatus: selectedRows.length
                  ? selectedRows
                  : [rowData],
                currentIndex: 0,
                previousScreen: location.pathname,
              },
            ]);
          },
          button_key: "F6",
        },
        {
          button_label: "Export as CSV",
          button_handeler: () => {
            exportAsCSV();
          },
          button_key: "",
        },
      ];

  const handleBack = () => {
    if (selectMode) {
      hideModal();
    } else if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    { button_label: "Back", button_handeler: handleBack, button_key: "F12" },
  ];

  const menuOptions = selectMode
    ? []
    : [
        {
          label: "Edit",
          icon: <span className="material-icons">edit</span>,
          command: () => {
            navigateToPage(EDIT_DRUG_STATUS_SCHEDULE, [
              ...previousState,
              { ...currentState, currentIndex },
              {
                selectedSchedules: selectedSchedules,
                selectedDescriptions: selectedDescriptions,
                bddDrugStatus: selectedRows.length ? selectedRows : [rowData],
                bddPreferredStatus: selectedRows.length
                  ? selectedRows
                  : [rowData],
                currentIndex: 0,
                previousScreen: location.pathname,
              },
            ]);
          },
        },
        {
          label: "Delete",
          icon: <span className="material-icons">delete</span>,
          command: () => {
            openConfirmationModal();
          },
        },
        {
          label: "Display",
          icon: <span className="material-icons">visibility</span>,
          command: () => {
            navigateToPage(DISPLAY_DRUG_STATUS_SCHEDULE, [
              ...previousState,
              { ...currentState, currentIndex },
              {
                selectedSchedules: selectedSchedules,
                selectedDescriptions: selectedDescriptions,
                bddDrugStatus: selectedRows.length ? selectedRows : [rowData],
                bddPreferredStatus: selectedRows.length
                  ? selectedRows
                  : [rowData],
                currentIndex: 0,
                previousScreen: location.pathname,
              },
            ]);
          },
        },
      ];

  const columnDef = [
    {
      header: "Code",
      field: "bddDrugStatus",
    },
    {
      header: "Description",
      field: "drugStatusDescription",
    },
    {
      header: "Status",
      field: "preferredStatus",
    },
  ];

  const parmKey = "bddDrugStatus";

  const fetchData = async () => {
    const page = first / rows;
    try {
      const raw_response = await axios_helper_no_header(
        "GET",
        `api/bddBenMaxDrugStsDet`,
        null,
        {
          page: page,
          size: rows,
          ...paramsData,
        }
      );
      const response = raw_response.responseData;
      const pageResponse = raw_response.responsePaginationDTO;
      if (response.length === 0) {
        setData([]);
        setTotalRecords(0);
        toast.current.show({
          severity: "info",
          summary: "",
          detail: response.responseStatus.message,
          life: 3000,
        });
      } else {
        setData(response);
        setTotalRecords(pageResponse.totalRecords);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRecords(0);
    }
  };

  const fetchDropdownData = async (dataDropdown) => {
    try {
      const response = await fetchDropdownValues(dataDropdown);
      setDropdownValues(response);
    } catch (error) {
      console.error("Error fetching dropdown values:", error);
    }
  };
  useEffect(() => {
    fetchDropdownData(dropdownCondition);
  }, []);

  useEffect(() => {
    fetchData();
  }, [paramsData, rows, currentPage]);
  useEffect(() => {
    if (initialIndex !== currentIndex) {
      setParamsData({
        bmdScheduleCode: selectedSchedules[currentIndex]?.bmdScheduleCode,
        bmdDescription: selectedDescriptions[currentIndex]?.bmdDescription,
        bddDrugStatus: "Blank",
      });
    }
  }, [currentIndex, initialIndex]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page);
    setRows(event.rows);
  };

  const openConfirmationModal = () => {
    setIsConfirmationModalOpen(true);
  };

  const closeConfirmationModal = () => {
    setIsConfirmationModalOpen(false);
    setSelectedOption("no");
  };

  const deleteDrugStatus = () => {
    if (selectedOption === "yes") {
      axios_helper_no_header("DELETE", "api/bddBenMaxDrugStsDet", null, {
        ...paramsData,
        bddDrugStatus: rowData[parmKey],
      })
        .then((response) => {
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);
          setTotalRecords((prevTotal) => prevTotal - 1);
          setData(updatedItems);
          toast.current.show({
            severity: "success",
            summary: "",
            detail: response.responseStatus.message,
            life: 3000,
          });
          closeConfirmationModal();
          if (currentPage > 0) {
            setFirst(0);
            setCurrentPage(0);
          } else {
            fetchData();
          }
        })
        .catch((error) => {
          console.error("There was an error deleting the data!", error);
          const {
            responseStatus: { displayErrorFields = null, message } = {},
          } = error.data;
          toast.current.show({
            severity: "error",
            summary: "",
            detail: message,
            life: 3000,
          });
          closeConfirmationModal();
        });
    } else {
      closeConfirmationModal();
    }
  };

  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/bddBenMaxDrugStsDet/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const updateParamData = (data) => {
    setFirst(0);
    setCurrentPage(0);
    setParamsData(data);
  };

  return {
    screenNumber,
    screen_title,
    formFields,
    dropdownValues,
    paramsData,
    updateParamData,
    ctaButtons,
    leftButtons,
    data,
    parmKey,
    menuOptions,
    columnDef,
    setRowData,
    selectedRows,
    setSelectedRows,
    first,
    rows,
    totalRecords,
    currentPage,
    onPageChange,
    isConfirmationModalOpen,
    closeConfirmationModal,
    deleteDrugStatus,
    setSelectedOption,
  };
};

export default useDrugStatusSchedule;
